var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"90vh"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('a',_vm._g(_vm._b({},'a',attrs,false),on),[_vm._v(" Datenschutzrichtlinien ")])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"height":"80vh"}},[_c('v-card-text',[_c('data-protection-content')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }